import TimeClockEntryStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('DELETE_TIME_CLOCK_ENTRY', function deleteTimeClockEntry(teamId: string) {
    if (TimeClockEntryStore().timeClockEntry.teamId === teamId) {
        // delete entry from the store if it exists
        TimeClockEntryStore().timeClockEntry = null;
    }
});